import './contact-exchange-container.component.ajscss';

import { IContact } from '@commons/models/contact';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { combineLatest } from 'rxjs';

import { AppConf, Booking, BookingFacade, Customer } from '@contact/upgrade';

import templateUrl from './contact-exchange-container.component.ajs.html';

const MODULE_NAME = 'contactExchangeContainerView';

export class ContactExchangeContainerCtrl implements IComponentController {
  public name = MODULE_NAME;

  contact$ = this.contactFacade.selected$;
  customer$ = this.contactFacade.selectedCustomer$;

  defaultViewInteractions: number;
  histoViewCompany: boolean | undefined;
  activeCustomer: boolean;
  activeCompany: boolean;
  contactNotBooking: IContact;

  contact: Booking | undefined;
  customer: Customer | undefined;
  unknownContact: boolean = false;
  contactCompanyName: string = '';

  constructor(private readonly appConf: AppConf, private readonly contactFacade: BookingFacade) {}

  $onInit(): void {
    this.appConf.pipe(ng1Destroy(this)).subscribe(({ defaultViewInteractions, histoViewCompany }) => {
      if (defaultViewInteractions) {
        this.defaultViewInteractions = Number(defaultViewInteractions);
      } else {
        this.defaultViewInteractions = 1;
      }
      if (histoViewCompany) {
        this.histoViewCompany = histoViewCompany;
      }
    });

    // compute all propretes from contact/customer informations
    combineLatest(this.contact$, this.customer$)
      .pipe(ng1Destroy(this))
      .subscribe(([contact, customer]) => {
        this.contact = contact;
        this.customer = customer;
        this.unknownContact = this.toUnknownContact(contact);
        this.contactCompanyName = this.toContactCompanyName(customer);
        this.activeCustomer = this.defaultViewInteractions === 1 || this.defaultViewInteractions !== 2 || this.contactCompanyName === '';
        this.activeCompany = this.defaultViewInteractions === 2 && this.contactCompanyName !== '';
      });
  }

  showCompanyTimelineInProcess(): void {
    if (this.contactCompanyName !== '') {
      this.activeCustomer = false;
      this.activeCompany = true;
    } else {
      this.activeCompany = false;
      this.activeCustomer = true;
    }
  }

  showCustomerTimelineInProcess(): void {
    this.activeCustomer = true;
    this.activeCompany = false;
  }

  private toUnknownContact(contact: Booking | undefined) {
    return !(contact && contact.customerId);
  }
  private toContactCompanyName(customer: Customer | undefined): string {
    return (customer && customer.companyname) || '';
  }
}

export class ContactExchangeContainer implements IComponentOptions {
  templateUrl = templateUrl;
  controller = ['appConf', 'contactFacade', ContactExchangeContainerCtrl];
}

export default MODULE_NAME;
